import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/constructionAsset/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/cityDigital/img/1.avif';
import image2 from '@src/assets/images/solution/cityDigital/img/2.avif';
import image3 from '@src/assets/images/solution/cityDigital/img/3.avif';
import image4 from '@src/assets/images/solution/cityDigital/img/4.avif';
import image5 from '@src/assets/images/solution/cityDigital/img/5.avif';
import image6 from '@src/assets/images/solution/cityDigital/img/6.avif';
import image7 from '@src/assets/images/solution/cityDigital/img/7.avif';
import image8 from '@src/assets/images/solution/cityDigital/img/8.avif';

export default {
  type: '都市ソリューション',

  banner: {
    title: '都市全体をリアルタイムで監視するデジタル災害対応体制',
    desc: '都市空間データを3Dデジタルツインで可視化し、災害の発生前後を予測・対応・復旧まで統合管理できるプラットフォームを提供します。',
  },

  video: {
    title: 'デジタルツインで災害管理のすべてをリアルタイム連携',
    desc: '実際の都市を仮想空間に再現し、センサー・位置データ・カメラ映像など多様な情報をリアルタイム反映して、災害前の早期警報、発生中の対応、事後復旧を一つのシステムで運用します。',
    play: video,
  },

  func: [
    {
      theme: '都市災害情報の統合とリアルタイム可視化',
      title: '都市インフラ基盤の統合モニタリング',
      desc: '道路・河川・施設・センサーデータなど、災害対応に必要な都市インフラ情報を一つのプラットフォームで統合管理し、都市全域の危険要素をリアルタイムで確認できます。',
      sub1: 'リアルタイム状況把握',
      icon1: IconClockGray,
      sub2: '高速データ連携',
      icon2: IconShareGray,
      image: image1,
    },
    {
      title: '気象情報のリアルタイム収集と分析',
      desc: '衛星画像、天気図、レーダーデータなどの気象情報をリアルタイムで収集し、悪天候に備えた予測とアラートを提供します。数値化された気象環境をシナリオ対応に活用できます。',
      sub1: '危険資産指定',
      icon1: IconWarningGray,
      sub2: 'クラウドデータ保存',
      icon2: IconCloudCheckGray,
      image: image2,
    },
    {
      title: '地域別降雨状況のリアルタイム確認',
      desc: '都市内の雨量計から地域別降雨データをリアルタイム収集・分析し、集中豪雨発生時に優先対応地域を判断できます。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウドデータ保存',
      icon2: IconCloudCheckGray,
      image: image3,
    },
    {
      title: '河川水位および流量状況の可視化',
      desc: '主要河川の水位・流量・水門状態をリアルタイム表示し、異常水位発生時に自動検知して警報を発信できます。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウドデータ保存',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      theme: '災害対応の自動化と状況室活用',
      title: '総合状況に基づくアラート連携',
      desc: '多様なデータを統合し、状況室画面で危険を一目で確認。条件に応じたカスタム警告と対応トリガーを自動実行します。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウドデータ保存',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      title: '状況室画面構成とリアルタイム表示',
      desc: '災害総合状況室では CCTV、警報履歴、主要河川水位などを大型スクリーンに分割表示し、リアルタイム監視を実施。迅速な現場対応と情報共有を支援します。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウドデータ保存',
      icon2: IconCloudCheckGray,
      image: image6,
    },
    {
      title: '災害時の遠隔対応体制',
      desc: 'TTSによる地域放送、SMS送信、CCTVモニタリング、遠隔遮断機制御など、災害時に遠隔から即時対応が可能です。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウドデータ保存',
      icon2: IconCloudCheckGray,
      image: image7,
    },
    {
      title: 'マルチパネルデータ可視化',
      desc: '気象情報、水位、降雨量、警報指標などを統合したデータパネルを提供し、各種環境情報を一画面で直感的に比較・判断できます。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウドデータ保存',
      icon2: IconCloudCheckGray,
      image: image8,
    },
  ],

  subfunc: {
    title: '多彩な機能',
    desc: '医療廃棄物は最後まで気を抜けません。わずかな油断やミスでも重大な医療事故につながる可能性があります。オブロは安全で効率的な医療施設構築のため、多彩な機能を提供します。',

    data: [
      {
        icon: IconDashboard,
        title: '都市全域モニタリング',
        desc: '道路や河川などのデータを一元管理。',
      },
      {
        icon: IconClockGray,
        title: '気象情報収集',
        desc: 'レーダーや衛星をリアルタイム可視化。',
      },
      {
        icon: IconChartBarGray,
        title: '地域降雨分析',
        desc: '雨量計データを自動分析し危険地域判別。',
      },
      {
        icon: IconChartBarGray,
        title: '河川水位モニタ',
        desc: '主要河川の水位・流量を数値化し警報設定。',
      },
      {
        icon: IconDashboard,
        title: '状況ダッシュボード',
        desc: 'CCTVやセンサーを統合表示。',
      },
      {
        icon: IconZoneGray,
        title: 'マルチ画面対応',
        desc: '大画面に目的別画面を分割表示。',
      },
      {
        icon: IconBell,
        title: '異常自動警報',
        desc: '条件達成時に自動で警報・通知。',
      },
      {
        icon: IconSecurity,
        title: 'CCTV連動制御',
        desc: 'CCTV映像と設備を遠隔制御。',
      },
      {
        icon: IconRoute,
        title: '災害シナリオ対応',
        desc: 'データで対応プラン自動実行。',
      },
      {
        icon: IconChartRadius,
        title: '履歴自動保存',
        desc: '全ての履歴を自動保存。',
      },
    ],
  },

  system: {
    title: 'システム構成',
    img: rtlsSystem,
  },

  productTitle: '製品構成',
  product: [{ tag: 'assetPackage' }, { tag: 'workerPackage' }],

  contents: [{ data: 'medicalPatient' }, { data: 'officeAsset' }, { data: 'blogMedical' }, { data: 'blogRTLS' }],
};
